import React from 'react';
import ActivityMediaPreviews from './ActivityMediaPreviews';
import { getAvatarVariantUrl } from '../../utils/avatarVariants';

export default function DojoActivityToast({ pill, backendService, onActivityClick }) {
  const typeIcons = { workout: '🏋️', meal: '🍽️', media: '📸', metric: '📊', survey: '📝' };
  const typeColors = { workout: '#8b5cf6', meal: '#10b981', media: '#f59e0b', metric: '#3b82f6', survey: '#ec4899' };
  const accentColor = typeColors[pill.activityType] || '#8b5cf6';
  const isCompletion = pill.event === 'completed';
  const avatarUrl = pill.user?.avatar_url ? getAvatarVariantUrl(pill.user, 'sm') : null;
  const initial = (pill.user?.display_name || 'M')[0].toUpperCase();
  const openActivity = () => {
    if (pill.activityId) {
      onActivityClick({ _id: pill.activityId }, pill.user || { display_name: 'Member' });
    }
  };
  return (
    <div
      key={`activity-${pill.id}`}
      className={`dojo-toast dojo-activity-toast ${pill.exiting ? 'exiting' : ''} ${isCompletion ? 'dojo-toast-completion' : 'dojo-toast-started'}`}
      style={{ '--toast-accent': accentColor, '--toast-timer-duration': pill.timerDuration ? `${pill.timerDuration}s` : '5s' }}
      role="button"
      tabIndex={0}
      onClick={openActivity}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openActivity();
        }
      }}
    >
      <div className="dojo-toast-accent" />
      <div className="dojo-toast-avatar">
        {avatarUrl
          ? <img src={avatarUrl} alt="" className="dojo-toast-avatar-img" />
          : <span className="dojo-toast-avatar-fallback">{initial}</span>
        }
      </div>
      <div className="dojo-toast-body">
        <span className="dojo-toast-message">{pill.message}</span>
        {pill.coachHighlight ? (
          <span className="dojo-toast-coach-highlight">{pill.coachHighlight}</span>
        ) : (
          <span className="dojo-toast-sub">Tap to view details</span>
        )}
      </div>
      {pill.activityType === 'media' && (
        <ActivityMediaPreviews
          activityId={pill.activityId}
          files={pill.mediaFiles}
          backendService={backendService}
          max={2}
          className="dojo-toast-media-previews"
          imageClassName="dojo-toast-media-preview"
        />
      )}
      <span className="dojo-toast-type-icon">{typeIcons[pill.activityType] || '📌'}</span>
      {isCompletion && <div className="dojo-toast-shimmer" />}
      <div className="dojo-toast-timer" />
    </div>
  );
}
